import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { MINIMUM_SEARCH_QUERY } from '../../queries/SEARCH_MINIMUM_QUERY';

export function useMinimalCourseQuery( variables, options = { fetchPolicy: 'network-only' } ) {

    const { data: rawData, loading, error, called } = useQuery( MINIMUM_SEARCH_QUERY, { variables, ...options } );

    const courses = useMemo( () => {
        return ( rawData?.search?.edges ?? [] )
            .map( e => e.node )
            .map( e => ( { 
                ...e,
                name: ( e.name.find( n => n.locale == 'en-US' ) ?? e.name[ 0 ] )?.content || '',
            } ) );
    }, [ rawData ] );

    return useMemo( () => {

        return {
            error,
            loading,
            courses,
            called,
            rawData
        };
    }, [ error, loading, courses, rawData, called ] );
}
